import * as React from 'react';
import * as styles from './styles.css';
import { Spinner } from '@cian/ui-kit';

interface ISupplyDemandWrapperParams {
  isLoading: boolean;
  children: React.ReactElement[];
}
export const SupplyDemandWrapper = React.forwardRef<HTMLDivElement, ISupplyDemandWrapperParams>(
  ({ children, isLoading }, ref) => {
    return isLoading ? (
      <div ref={ref} className={styles['wrapper']}>
        {<Spinner size={32} color="icon-main-default" />}
      </div>
    ) : (
      <div ref={ref}>{children}</div>
    );
  },
);

SupplyDemandWrapper.displayName = 'SupplyDemandWrapper';
